<div class="booking-instruction-panel">
    <div class="header">
        <div class="heading">
            <div class="displayFlex mr-4">
                <img src="assets/instruction.svg" style="width: 18px;"/><span>Booking Instruction</span>

            </div>
            <!-- <div  class="close">
                <img src="assets/images/cancel_24.svg" alt="">
            </div> -->
        </div>
        <div class="subheadings-wrapper">
            <span class="subheading-bold">Booking Cut-offs</span>
            <span class="subheading">Please find different cutoffs for each of the following booking types. </span>

        </div>
        <div class="disclaimer">
            <div class="displayFlex">
                <span><img src="assets/policy-error.svg" alt=""></span>
                <span class="ml-4 fs-12 font-weight-700 mb-12 ">Cancellation Cut-off Policies</span>
            </div>
            <ul class="fs-12">
                <li class="mb-8 fs-12">If bookings are modified / cancelled 4 hours before pickup time, there will be no cost charged.</li>
                <li class="fs-12">Cancellations within 4 hours of the pickup time will be treated as No-Show & the minimum amount for
                    the selected Disposals duty as per vehicle type will be charged.</li>
            </ul>
        </div>
    </div>
    
    <div *ngIf="enableCityWiseCreationCutOff; else cityCutoff" class="width-full">
        <div class="fs-16 font-weight-700 mb-12 color-181F33 width-full">City</div>
        <div class="mb-24 width-full">
            <mis-dropdown [data]="cities" [searchEnabled]="true" [label]="firstCity" height="38px" width="250px"
            dropdownListHeight="232px" dropdownListWidth="250px" dropdownListPosition="Left" noDataMessage="No Data"
            (onChange)="citySelect($event)">
        </mis-dropdown>
        </div>
        
        <div class="instruction" *ngIf="!emptyState">
            <details class="instruction-details fs-12" *ngFor="let i of instructionData" open>
                 <summary><div class="booking-type"><img [src]="i.icon" alt=""/>{{i.displayName}}</div> <img src="assets/caret-down-large.svg" alt="" class="arrow"/></summary>
                 <div class="instruction-data">
                     <span>{{i.description}}</span>
                     <ul>
                         <li *ngFor="let j of i.instruction" [innerHTML]="j"></li>
                     </ul>
                 </div>
            </details>
        </div> 
        <ng-template [ngIf]="emptyState">
            <div class="displayFlexColumn align-item-center">
                <span class="mb-16" >Cut-offs for this city have not been configured. </span>
            <span class=""><img src="assets/emptyPolicy.svg" alt=""></span>
            </div>
            
        </ng-template>
    </div>
    <ng-template #cityCutoff>
        <div class="instruction" >
            <details class="instruction-details fs-12" *ngFor="let i of instructionData" open>
                 <summary><div class="booking-type"><img [src]="i.icon" alt=""/>{{i.displayName}}</div> <img src="assets/caret-down-large.svg" alt="" class="arrow"/></summary>
                 <div class="instruction-data">
                     <span>{{i.description}}</span>
                     <ul >
                         <li *ngFor="let j of i.instruction" [innerHTML]="j"></li>
                     </ul>
                 </div>
            </details>
         </div> 
    </ng-template>
</div>
